import { useCallback, useEffect, useMemo, useState } from 'react';
import './App.css';

const API_BASE = process.env.REACT_APP_API_BASE
  || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8080/api'
    : '/api');

const LANGS = ['de', 'en', 'ru'];

const DICT = {
  de: {
    navSearch: 'Suche',
    navWipes: 'Wipes',
    navCompare: 'Vergleich',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Finde den perfekten Rust-Server.',
    heroCopy: 'Suche nach Wipe, Teamlimit, Rates, Region, Ping, Modded/Vanilla, Aktivität und Datenqualität.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Suchen',
    all: 'Alle',
    servers: 'Server',
    playersOnline: 'Spieler online',
    justWiped: 'Gerade gewiped',
    verifiedServers: 'Starke Datenquellen',
    liveServers: 'Live-Server',
    topServers: 'Top-Server',
    bestDuo: 'Beste Duo Server',
    bestVanilla: 'Beste Vanilla Server',
    upcomingWipes: 'Kommende Wipes',
    verified: 'Owner-verifiziert',
    officialTag: 'Steam-Tags',
    nameDetected: 'Aus Name erkannt',
    historyEstimated: 'Historisch geschätzt',
    uncertain: 'Unsicher',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam Born-Tag',
    sourceEstimate: 'Geschätzt',
    source: 'Quelle',
    confidence: 'Sicherheit',
    quickFilters: 'Schnellfilter',
    advancedFilters: 'Erweiterte Filter',
    region: 'Region',
    type: 'Typ',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Qualität',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Niedriger Ping',
    highPop: 'Hohe Pop',
    noBp: 'Kein BP-Wipe',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Offiziell',
    community: 'Community',
    premium: 'Premium',
    players: 'Spieler',
    ping: 'Ping',
    nextWipe: 'Nächster Wipe',
    lastWipe: 'Letzter Wipe',
    map: 'Map',
    mapSize: 'Map Size',
    bpWipe: 'BP-Wipe',
    dataQuality: 'Datenqualität',
    connect: 'Beitreten',
    copyIp: 'IP kopieren',
    details: 'Details',
    compare: 'Vergleichen',
    alert: 'Alarm',
    favorite: 'Favorit',
    remove: 'Entfernen',
    empty: 'Keine passenden Server gefunden.',
    quietError: 'Daten werden gerade aktualisiert. Bitte gleich erneut versuchen.',
    profile: 'Serverprofil',
    overview: 'Überblick',
    history: 'Historie',
    rules: 'Regeln',
    fullName: 'Vollständiger Name',
    endpoint: 'IP und Port',
    status: 'Status',
    mode: 'Modus',
    ownerStatus: 'Owner-Status',
    notClaimed: 'Nicht geclaimt',
    snapshots: 'Spieler 24h',
    wipeHistory: 'Wipe-Historie',
    noHistory: 'Noch keine Historie vorhanden.',
    close: 'Schließen',
    compareServers: 'Server vergleichen',
    compareHint: 'Wähle 2 bis 4 Server aus.',
    createAlert: 'Alarm erstellen',
    alertCopy: 'Wir merken uns diesen Suchwunsch im Browser. Backend-Benachrichtigungen können später E-Mail, Discord oder Telegram senden.',
    saveAlert: 'Alarm speichern',
    savedAlert: 'Alarm gespeichert',
    copied: 'Kopiert',
    connectCopied: 'Connect-Befehl kopiert',
    recommended: 'Empfohlen',
    ranking: 'Rust Radar Score',
    noBpWipe: 'Kein BP-Wipe',
    yes: 'Ja',
    no: 'Nein',
    unknown: 'Unbekannt',
    online: 'Online',
    offline: 'Offline',
    today: 'Heute',
    tomorrow: 'Morgen',
    seoTitle: 'Beliebte Rust-Suchen',
    footerCopy: 'Jede Information bekommt eine Quelle. Jede Schätzung bekommt einen Confidence Score.',
    from: 'Von',
    to: 'Bis',
    playersRange: 'Spieler',
    maxPlayersRange: 'Slots',
    pingRange: 'Ping (ms)',
    gatherRange: 'Gather x',
    teamRange: 'Teamgröße',
    qualityRange: 'Qualität %',
    wipeAgeRange: 'Wipe-Alter (Min.)',
    nextWipeRange: 'Nächster Wipe (Std.)',
    mapSizeRange: 'Map Size',
    queue: 'Warteschlange',
    activePlayers: 'Aktive Spieler',
    updatedAgo: 'Aktualisiert',
    scoreBreakdown: 'Score-Erklärung',
    scoreWipe: 'Wipe-Frische',
    scorePopulation: 'Population',
    scoreQuality: 'Datenqualität',
    scorePing: 'Ping',
    scoreStatus: 'Status',
    scoreRisk: 'Risiko',
    freshWipe: 'Frischer Wipe',
    stablePop: 'Stabile Pop',
    strongData: 'Daten stark',
    bpUnclear: 'BP-Wipe unsicher',
    queueDetected: 'Queue erkannt',
    dataWarning: 'Datenwarnung',
    fakeRiskLow: 'Fake-Pop-Risiko niedrig',
    fakeRiskMedium: 'Ungewöhnliche Player-Zahl',
    fakeRiskHigh: 'Player-Zahl über Slots prüfen',
    allFilters: 'Alle Filter',
    hideFilters: 'Filter ausblenden',
    resetFilters: 'Filter zurücksetzen',
    emptyFiltered: 'Aktuell keine passenden Server im aktiven Filter.',
    showWorldwide: 'Weltweit anzeigen',
    wipeUnder10: '0-10 Minuten',
    wipe10to30: '10-30 Minuten',
    wipe30to60: '30-60 Minuten',
    wipedToday: 'Heute gewiped',
    wipeHubCopy: 'Frische Wipes nach Alter, Aktivität und Datenqualität sortiert.',
    landingCopy: 'Diese Landingpage nutzt echte Live-Daten und setzt passende Filter automatisch.',
    compareSelected: 'Server ausgewählt',
    clear: 'Leeren',
    openCompare: 'Vergleichen',
    sourceDetails: 'Quellen-Details',
    ownerVerifiedOnly: 'Nur echte Owner-Claims werden als verifiziert markiert.',
    loginSteam: 'Mit Steam einloggen',
    logout: 'Ausloggen',
    account: 'Account',
    admin: 'Admin',
    adminPanel: 'Sponsor-Steuerung',
    adminLogin: 'Admin-Login',
    adminPassword: 'Admin-Passwort',
    login: 'Einloggen',
    signedInAs: 'Eingeloggt als',
    favorites: 'Favoriten',
    noFavorites: 'Noch keine Favoriten gespeichert.',
    sponsorAdmin: 'Sponsoren verwalten',
    sponsorTitle: 'Sponsor-Titel',
    sponsorDescription: 'Beschreibung',
    sponsorImage: 'Bild-URL',
    sponsorTarget: 'Ziel-URL',
    sponsorPlacement: 'Platzierung',
    sponsorServerId: 'Server-ID optional',
    sponsorPriority: 'Priorität',
    sponsorActive: 'Aktiv',
    sponsorStarts: 'Start',
    sponsorEnds: 'Ende',
    saveSponsor: 'Sponsor speichern',
    newSponsor: 'Neuer Sponsor',
    deleteSponsor: 'Löschen',
    sponsorLive: 'Live-Sponsoren',
    sponsored: 'Gesponsert',
    sponsorCopy: 'Fair markierte Sponsorenplätze mit Startzeit, Endzeit und Priorität.',
    adminHint: 'Hier steuerst du, wer wann auf der Seite angezeigt wird.',
    steamLoginCopy: 'Steam-Login läuft über die offizielle Steam-OpenID-Seite. Rust Radar sieht keine Steam-Passwörter.',
    loginRequiredFavorite: 'Für Account-Favoriten bitte mit Steam einloggen.',
    favoriteSaved: 'Favorit gespeichert',
    favoriteRemoved: 'Favorit entfernt',
    manageSponsors: 'Sponsoren steuern',
    currentSponsors: 'Aktuelle Sponsoren',
  },
  en: {
    navSearch: 'Search',
    navWipes: 'Wipes',
    navCompare: 'Compare',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Find the perfect Rust server.',
    heroCopy: 'Search by wipe, team limit, rates, region, ping, modded/vanilla, activity and data quality.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Search',
    all: 'All',
    servers: 'Servers',
    playersOnline: 'Players online',
    justWiped: 'Just wiped',
    verifiedServers: 'Strong data sources',
    liveServers: 'Live servers',
    topServers: 'Top servers',
    bestDuo: 'Best duo servers',
    bestVanilla: 'Best vanilla servers',
    upcomingWipes: 'Upcoming wipes',
    verified: 'Owner verified',
    officialTag: 'Steam tags',
    nameDetected: 'Detected from name',
    historyEstimated: 'History estimate',
    uncertain: 'Uncertain',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam born tag',
    sourceEstimate: 'Estimated',
    source: 'Source',
    confidence: 'Confidence',
    quickFilters: 'Quick filters',
    advancedFilters: 'Advanced filters',
    region: 'Region',
    type: 'Type',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Quality',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Low ping',
    highPop: 'High pop',
    noBp: 'No BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Players',
    ping: 'Ping',
    nextWipe: 'Next wipe',
    lastWipe: 'Last wipe',
    map: 'Map',
    mapSize: 'Map size',
    bpWipe: 'BP wipe',
    dataQuality: 'Data quality',
    connect: 'Connect',
    copyIp: 'Copy IP',
    details: 'Details',
    compare: 'Compare',
    alert: 'Alert',
    favorite: 'Favorite',
    remove: 'Remove',
    empty: 'No matching servers found.',
    quietError: 'Data is being refreshed. Please try again shortly.',
    profile: 'Server profile',
    overview: 'Overview',
    history: 'History',
    rules: 'Rules',
    fullName: 'Full name',
    endpoint: 'IP and port',
    status: 'Status',
    mode: 'Mode',
    ownerStatus: 'Owner status',
    notClaimed: 'Not claimed',
    snapshots: 'Players 24h',
    wipeHistory: 'Wipe history',
    noHistory: 'No history yet.',
    close: 'Close',
    compareServers: 'Compare servers',
    compareHint: 'Select 2 to 4 servers.',
    createAlert: 'Create alert',
    alertCopy: 'This search is stored in your browser. Backend notifications can later send email, Discord or Telegram.',
    saveAlert: 'Save alert',
    savedAlert: 'Alert saved',
    copied: 'Copied',
    connectCopied: 'Connect command copied',
    recommended: 'Recommended',
    ranking: 'Rust Radar score',
    noBpWipe: 'No BP wipe',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    online: 'Online',
    offline: 'Offline',
    today: 'Today',
    tomorrow: 'Tomorrow',
    seoTitle: 'Popular Rust searches',
    footerCopy: 'Every fact gets a source. Every estimate gets a confidence score.',
    from: 'From',
    to: 'To',
    playersRange: 'Players',
    maxPlayersRange: 'Slots',
    pingRange: 'Ping (ms)',
    gatherRange: 'Gather x',
    teamRange: 'Team size',
    qualityRange: 'Quality %',
    wipeAgeRange: 'Wipe age (min.)',
    nextWipeRange: 'Next wipe (h)',
    mapSizeRange: 'Map size',
    queue: 'Queue',
    activePlayers: 'Active players',
    updatedAgo: 'Updated',
    scoreBreakdown: 'Score breakdown',
    scoreWipe: 'Wipe freshness',
    scorePopulation: 'Population',
    scoreQuality: 'Data quality',
    scorePing: 'Ping',
    scoreStatus: 'Status',
    scoreRisk: 'Risk',
    freshWipe: 'Fresh wipe',
    stablePop: 'Stable pop',
    strongData: 'Strong data',
    bpUnclear: 'BP wipe unclear',
    queueDetected: 'Queue detected',
    dataWarning: 'Data warning',
    fakeRiskLow: 'Fake-pop risk low',
    fakeRiskMedium: 'Unusual player count',
    fakeRiskHigh: 'Player count above slots',
    allFilters: 'All filters',
    hideFilters: 'Hide filters',
    resetFilters: 'Reset filters',
    emptyFiltered: 'No servers match the active filter right now.',
    showWorldwide: 'Show worldwide',
    wipeUnder10: '0-10 minutes',
    wipe10to30: '10-30 minutes',
    wipe30to60: '30-60 minutes',
    wipedToday: 'Wiped today',
    wipeHubCopy: 'Fresh wipes sorted by age, activity and data quality.',
    landingCopy: 'This landing page uses live data and applies the matching filters automatically.',
    compareSelected: 'servers selected',
    clear: 'Clear',
    openCompare: 'Compare',
    sourceDetails: 'Source details',
    ownerVerifiedOnly: 'Only real owner claims are marked as verified.',
    loginSteam: 'Sign in with Steam',
    logout: 'Log out',
    account: 'Account',
    admin: 'Admin',
    adminPanel: 'Sponsor control',
    adminLogin: 'Admin login',
    adminPassword: 'Admin password',
    login: 'Log in',
    signedInAs: 'Signed in as',
    favorites: 'Favorites',
    noFavorites: 'No favorites saved yet.',
    sponsorAdmin: 'Manage sponsors',
    sponsorTitle: 'Sponsor title',
    sponsorDescription: 'Description',
    sponsorImage: 'Image URL',
    sponsorTarget: 'Target URL',
    sponsorPlacement: 'Placement',
    sponsorServerId: 'Server ID optional',
    sponsorPriority: 'Priority',
    sponsorActive: 'Active',
    sponsorStarts: 'Starts',
    sponsorEnds: 'Ends',
    saveSponsor: 'Save sponsor',
    newSponsor: 'New sponsor',
    deleteSponsor: 'Delete',
    sponsorLive: 'Live sponsors',
    sponsored: 'Sponsored',
    sponsorCopy: 'Clearly marked sponsor placements with start time, end time and priority.',
    adminHint: 'Control who appears on the site and when.',
    steamLoginCopy: 'Steam login uses the official Steam OpenID page. Rust Radar never sees Steam passwords.',
    loginRequiredFavorite: 'Sign in with Steam for account favorites.',
    favoriteSaved: 'Favorite saved',
    favoriteRemoved: 'Favorite removed',
    manageSponsors: 'Control sponsors',
    currentSponsors: 'Current sponsors',
  },
  ru: {
    navSearch: 'Поиск',
    navWipes: 'Вайпы',
    navCompare: 'Сравнение',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Найди идеальный Rust-сервер.',
    heroCopy: 'Поиск по вайпу, лимиту команды, рейтам, региону, пингу, модам, активности и качеству данных.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Искать',
    all: 'Все',
    servers: 'Серверы',
    playersOnline: 'Игроков онлайн',
    justWiped: 'Недавний вайп',
    verifiedServers: 'Сильные источники',
    liveServers: 'Live серверы',
    topServers: 'Топ серверы',
    bestDuo: 'Лучшие Duo',
    bestVanilla: 'Лучшие Vanilla',
    upcomingWipes: 'Скоро вайп',
    verified: 'Owner подтвержден',
    officialTag: 'Steam теги',
    nameDetected: 'Из названия',
    historyEstimated: 'Оценка по истории',
    uncertain: 'Неуверенно',
    sourceA2s: 'A2S + Steam',
    sourceBorn: 'Steam born тег',
    sourceEstimate: 'Оценка',
    source: 'Источник',
    confidence: 'Уверенность',
    quickFilters: 'Быстрые фильтры',
    advancedFilters: 'Фильтры',
    region: 'Регион',
    type: 'Тип',
    team: 'Команда',
    gather: 'Рейт',
    wipe: 'Вайп',
    quality: 'Качество',
    population: 'Онлайн',
    sort: 'Рейтинг',
    lowPing: 'Низкий пинг',
    highPop: 'Высокий онлайн',
    noBp: 'Без BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Игроки',
    ping: 'Пинг',
    nextWipe: 'Следующий вайп',
    lastWipe: 'Последний вайп',
    map: 'Карта',
    mapSize: 'Размер карты',
    bpWipe: 'BP вайп',
    dataQuality: 'Качество данных',
    connect: 'Подключиться',
    copyIp: 'Копировать IP',
    details: 'Детали',
    compare: 'Сравнить',
    alert: 'Оповещение',
    favorite: 'Избранное',
    remove: 'Удалить',
    empty: 'Подходящих серверов нет.',
    quietError: 'Данные обновляются. Попробуй еще раз чуть позже.',
    profile: 'Профиль сервера',
    overview: 'Обзор',
    history: 'История',
    rules: 'Правила',
    fullName: 'Полное название',
    endpoint: 'IP и порт',
    status: 'Статус',
    mode: 'Режим',
    ownerStatus: 'Owner статус',
    notClaimed: 'Не подтвержден',
    snapshots: 'Игроки 24ч',
    wipeHistory: 'История вайпов',
    noHistory: 'Истории пока нет.',
    close: 'Закрыть',
    compareServers: 'Сравнить серверы',
    compareHint: 'Выбери от 2 до 4 серверов.',
    createAlert: 'Создать оповещение',
    alertCopy: 'Этот поиск сохранится в браузере. Позже backend сможет отправлять email, Discord или Telegram.',
    saveAlert: 'Сохранить оповещение',
    savedAlert: 'Оповещение сохранено',
    copied: 'Скопировано',
    connectCopied: 'Connect команда скопирована',
    recommended: 'Рекомендуем',
    ranking: 'Rust Radar score',
    noBpWipe: 'Без вайпа чертежей',
    yes: 'Да',
    no: 'Нет',
    unknown: 'Неизвестно',
    online: 'Онлайн',
    offline: 'Оффлайн',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    seoTitle: 'Популярные поиски Rust',
    footerCopy: 'У каждой информации есть источник. У каждой оценки есть confidence score.',
    from: 'От',
    to: 'До',
    playersRange: 'Игроки',
    maxPlayersRange: 'Слоты',
    pingRange: 'Пинг (мс)',
    gatherRange: 'Рейт x',
    teamRange: 'Размер команды',
    qualityRange: 'Качество %',
    wipeAgeRange: 'Возраст вайпа (мин.)',
    nextWipeRange: 'Следующий вайп (ч)',
    mapSizeRange: 'Размер карты',
    queue: 'Очередь',
    activePlayers: 'Активные игроки',
    updatedAgo: 'Обновлено',
    scoreBreakdown: 'Разбор score',
    scoreWipe: 'Свежесть вайпа',
    scorePopulation: 'Онлайн',
    scoreQuality: 'Качество данных',
    scorePing: 'Пинг',
    scoreStatus: 'Статус',
    scoreRisk: 'Риск',
    freshWipe: 'Свежий вайп',
    stablePop: 'Стабильный онлайн',
    strongData: 'Сильные данные',
    bpUnclear: 'BP вайп неясен',
    queueDetected: 'Очередь найдена',
    dataWarning: 'Предупреждение',
    fakeRiskLow: 'Риск fake-pop низкий',
    fakeRiskMedium: 'Необычный онлайн',
    fakeRiskHigh: 'Онлайн выше слотов',
    allFilters: 'Все фильтры',
    hideFilters: 'Скрыть фильтры',
    resetFilters: 'Сбросить фильтры',
    emptyFiltered: 'Сейчас нет серверов под активный фильтр.',
    showWorldwide: 'Показать все регионы',
    wipeUnder10: '0-10 минут',
    wipe10to30: '10-30 минут',
    wipe30to60: '30-60 минут',
    wipedToday: 'Вайп сегодня',
    wipeHubCopy: 'Свежие вайпы по возрасту, активности и качеству данных.',
    landingCopy: 'Эта страница использует live-данные и автоматически применяет фильтры.',
    compareSelected: 'серверов выбрано',
    clear: 'Очистить',
    openCompare: 'Сравнить',
    sourceDetails: 'Детали источников',
    ownerVerifiedOnly: 'Только реальные owner claims отмечаются как подтвержденные.',
    loginSteam: 'Войти через Steam',
    logout: 'Выйти',
    account: 'Аккаунт',
    admin: 'Админ',
    adminPanel: 'Управление спонсорами',
    adminLogin: 'Админ вход',
    adminPassword: 'Админ пароль',
    login: 'Войти',
    signedInAs: 'Вошел как',
    favorites: 'Избранное',
    noFavorites: 'Избранных серверов пока нет.',
    sponsorAdmin: 'Управлять спонсорами',
    sponsorTitle: 'Название спонсора',
    sponsorDescription: 'Описание',
    sponsorImage: 'URL картинки',
    sponsorTarget: 'Целевой URL',
    sponsorPlacement: 'Место',
    sponsorServerId: 'Server ID optional',
    sponsorPriority: 'Приоритет',
    sponsorActive: 'Активно',
    sponsorStarts: 'Старт',
    sponsorEnds: 'Конец',
    saveSponsor: 'Сохранить спонсора',
    newSponsor: 'Новый спонсор',
    deleteSponsor: 'Удалить',
    sponsorLive: 'Live спонсоры',
    sponsored: 'Спонсор',
    sponsorCopy: 'Честно отмеченные спонсорские места со стартом, концом и приоритетом.',
    adminHint: 'Управляй кто и когда показывается на сайте.',
    steamLoginCopy: 'Steam вход идет через официальную Steam OpenID страницу. Rust Radar не видит пароли Steam.',
    loginRequiredFavorite: 'Войди через Steam для account favorites.',
    favoriteSaved: 'Избранное сохранено',
    favoriteRemoved: 'Избранное удалено',
    manageSponsors: 'Управлять спонсорами',
    currentSponsors: 'Текущие спонсоры',
  }
};

const defaultFilters = {
  query: '',
  mode: 'all',
  region: 'all',
  gather: 'all',
  group: 'all',
  wipe: 'all',
  minPlayers: 0,
  playersMin: '',
  playersMax: '',
  maxPlayersMin: '',
  maxPlayersMax: '',
  pingMin: '',
  pingMax: '',
  gatherMin: '',
  gatherMax: '',
  teamMin: '',
  teamMax: '',
  qualityMin: '',
  qualityMax: '',
  wipeAgeMin: '',
  wipeAgeMax: '',
  nextWipeMin: '',
  nextWipeMax: '',
  mapSizeMin: '',
  mapSizeMax: '',
  sort: 'confidence',
  onlineOnly: true,
  quality: 'all',
  population: 'all',
  bp: 'all',
  lowPing: false
};

const quickFilters = [
  { id: 'just-wiped', labelKey: 'justWiped', patch: { wipe: 'all', sort: 'wipe' }, local: { justWiped: true } },
  { id: 'eu', label: 'EU', patch: { region: 'EU' } },
  { id: 'solo', label: 'Solo', patch: { group: 'solo' } },
  { id: 'duo', label: 'Duo', patch: { group: 'duo' } },
  { id: 'trio', label: 'Trio', patch: { group: 'trio' } },
  { id: '2x', label: '2x', patch: { gather: '2x' } },
  { id: 'vanilla', labelKey: 'vanilla', patch: { mode: 'vanilla' } },
  { id: 'monthly', labelKey: 'monthly', patch: { wipe: 'monthly' } },
  { id: 'no-bp', labelKey: 'noBp', patch: { bp: 'no' } },
  { id: 'pve', label: 'PvE', patch: { mode: 'pve' } },
  { id: 'low-ping', labelKey: 'lowPing', patch: { lowPing: true } }
];

const landingPages = [
  { path: '/de/wipes', label: 'Rust Server gerade gewiped', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/en/just-wiped-rust-servers', label: 'Just Wiped Rust Servers', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/ru/wipes', label: 'Недавние Rust вайпы', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/de/rust-duo-server', label: 'Beste Rust Duo Server', patch: { group: 'duo' } },
  { path: '/en/rust-duo-servers', label: 'Best Rust Duo Servers', patch: { group: 'duo' } },
  { path: '/ru/rust-duo-серверы', label: 'Rust Duo серверы', patch: { group: 'duo' } },
  { path: '/de/rust-2x-server', label: 'Rust 2x Server', patch: { gather: '2x' } },
  { path: '/de/deutsche-rust-server', label: 'Deutsche Rust Server', patch: { region: 'EU', query: 'german deutsch' } },
  { path: '/en/rust-vanilla-servers', label: 'Rust Vanilla Servers', patch: { mode: 'vanilla' } },
  { path: '/en/rust-no-bp-wipe-servers', label: 'No BP Wipe Servers', patch: { bp: 'no' } }
];

function hasValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== '';
}

function addRangeParam(params, key, value) {
  if (hasValue(value)) {
    params.set(key, String(value).trim());
  }
}

function isQuickFilterActive(chip, filters, localFlags) {
  const patchActive = Object.entries(chip.patch || {}).every(([key, value]) => filters[key] === value);
  const localActive = Object.entries(chip.local || {}).every(([key, value]) => localFlags[key] === value);
  return patchActive && localActive;
}

function emptySponsorDraft() {
  return {
    id: null,
    title: '',
    description: '',
    imageUrl: '',
    targetUrl: '',
    placement: 'home_top',
    serverId: '',
    active: true,
    priority: 0,
    startsAt: '',
    endsAt: ''
  };
}

function draftFromSponsor(sponsor) {
  return {
    id: sponsor.id,
    title: sponsor.title || '',
    description: sponsor.description || '',
    imageUrl: sponsor.imageUrl || '',
    targetUrl: sponsor.targetUrl || '',
    placement: sponsor.placement || 'home_top',
    serverId: sponsor.serverId || '',
    active: sponsor.active !== false,
    priority: sponsor.priority || 0,
    startsAt: toDateTimeLocal(sponsor.startsAt),
    endsAt: toDateTimeLocal(sponsor.endsAt)
  };
}

function sponsorPayload(draft) {
  return {
    title: draft.title,
    description: draft.description,
    imageUrl: draft.imageUrl,
    targetUrl: draft.targetUrl,
    placement: draft.placement || 'home_top',
    serverId: hasValue(draft.serverId) ? Number(draft.serverId) : null,
    active: draft.active,
    priority: hasValue(draft.priority) ? Number(draft.priority) : 0,
    startsAt: draft.startsAt ? new Date(draft.startsAt).toISOString() : null,
    endsAt: draft.endsAt ? new Date(draft.endsAt).toISOString() : null
  };
}

function toDateTimeLocal(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('rustRadarLang') || detectLanguage());
  const [smartQuery, setSmartQuery] = useState('');
  const [filters, setFilters] = useState(defaultFilters);
  const [localFlags, setLocalFlags] = useState({});
  const [servers, setServers] = useState([]);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [softError, setSoftError] = useState(false);
  const [selected, setSelected] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [wipes, setWipes] = useState([]);
  const [toast, setToast] = useState('');
  const [compareIds, setCompareIds] = useState(() => readJson('rustRadarCompare', []));
  const [favoriteIds, setFavoriteIds] = useState(() => readJson('rustRadarFavorites', []));
  const [alertOpen, setAlertOpen] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [currentUser, setCurrentUser] = useState({ authenticated: false, admin: false, adminVisible: false });
  const [accountFavorites, setAccountFavorites] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [adminSponsors, setAdminSponsors] = useState([]);
  const [adminPassword, setAdminPassword] = useState('');
  const [sponsorDraft, setSponsorDraft] = useState(emptySponsorDraft());
  const [routePath, setRoutePath] = useState(window.location.pathname);

  const t = DICT[lang] || DICT.de;
  const activeLanding = landingPages.find((pageItem) => pageItem.path === routePath);

  useEffect(() => {
    localStorage.setItem('rustRadarLang', lang);
  }, [lang]);

  useEffect(() => {
    const match = landingPages.find((pageItem) => pageItem.path === window.location.pathname);
    if (match) {
      setFilters((current) => ({ ...current, ...match.patch }));
      setLocalFlags(match.local || {});
    }
  }, []);

  useEffect(() => {
    const onRoute = () => setRoutePath(window.location.pathname);
    window.addEventListener('popstate', onRoute);
    return () => window.removeEventListener('popstate', onRoute);
  }, []);

  useEffect(() => {
    localStorage.setItem('rustRadarCompare', JSON.stringify(compareIds));
  }, [compareIds]);

  useEffect(() => {
    localStorage.setItem('rustRadarFavorites', JSON.stringify(favoriteIds));
  }, [favoriteIds]);

  const request = useCallback(async (path, options = {}) => {
    const response = await fetch(`${API_BASE}${path}`, {
      credentials: 'include',
      ...options,
      headers: {
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      }
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `HTTP ${response.status}`);
    }
    if (response.status === 204) {
      return null;
    }
    return response.json();
  }, []);

  const queryString = useMemo(() => {
    const params = new URLSearchParams({
      page: String(page),
      size: '200',
      mode: filters.mode,
      region: filters.region,
      gather: filters.gather,
      group: filters.group,
      wipe: filters.wipe,
      sort: filters.sort === 'radar' ? 'confidence' : filters.sort,
      onlineOnly: String(filters.onlineOnly)
    });
    if (filters.query.trim()) params.set('query', filters.query.trim());
    if (filters.bp !== 'all') params.set('bpWipe', filters.bp);
    if (Number(filters.minPlayers) > 0) params.set('minPlayers', String(filters.minPlayers));
    if (!hasValue(filters.playersMin) && Number(filters.minPlayers) > 0) {
      params.set('playersMin', String(filters.minPlayers));
    }
    addRangeParam(params, 'playersMin', filters.playersMin);
    addRangeParam(params, 'playersMax', filters.playersMax);
    addRangeParam(params, 'maxPlayersMin', filters.maxPlayersMin);
    addRangeParam(params, 'maxPlayersMax', filters.maxPlayersMax);
    addRangeParam(params, 'pingMin', filters.pingMin);
    addRangeParam(params, 'pingMax', filters.pingMax);
    addRangeParam(params, 'gatherMin', filters.gatherMin);
    addRangeParam(params, 'gatherMax', filters.gatherMax);
    addRangeParam(params, 'teamMin', filters.teamMin);
    addRangeParam(params, 'teamMax', filters.teamMax);
    addRangeParam(params, 'qualityMin', filters.qualityMin);
    addRangeParam(params, 'qualityMax', filters.qualityMax);
    addRangeParam(params, 'wipeAgeMinMinutes', filters.wipeAgeMin);
    addRangeParam(params, 'wipeAgeMaxMinutes', filters.wipeAgeMax);
    addRangeParam(params, 'nextWipeMinHours', filters.nextWipeMin);
    addRangeParam(params, 'nextWipeMaxHours', filters.nextWipeMax);
    addRangeParam(params, 'mapSizeMin', filters.mapSizeMin);
    addRangeParam(params, 'mapSizeMax', filters.mapSizeMax);
    return params.toString();
  }, [filters, page]);

  const loadServers = useCallback(async () => {
    try {
      const data = await request(`/servers?${queryString}`);
      setServers(data.items || []);
      setTotal(data.total || 0);
      setSoftError(false);
    } catch {
      setSoftError(true);
      setServers([]);
      setTotal(0);
    }
  }, [queryString, request]);

  const loadStats = useCallback(async () => {
    try {
      setStats(await request('/stats'));
    } catch {
      setStats(null);
    }
  }, [request]);

  const loadMe = useCallback(async () => {
    try {
      const me = await request('/auth/me');
      setCurrentUser(me || { authenticated: false, admin: false, adminVisible: false });
    } catch {
      setCurrentUser({ authenticated: false, admin: false, adminVisible: false });
    }
  }, [request]);

  const loadSponsors = useCallback(async () => {
    try {
      setSponsors(await request('/sponsors?placement=home_top'));
    } catch {
      setSponsors([]);
    }
  }, [request]);

  const loadAccountFavorites = useCallback(async () => {
    if (!currentUser.authenticated || currentUser.admin) {
      setAccountFavorites([]);
      return;
    }
    try {
      setAccountFavorites((await request('/me/favorites')).map((server) => enrichServer(server)));
    } catch {
      setAccountFavorites([]);
    }
  }, [currentUser.authenticated, currentUser.admin, request]);

  const loadAdminSponsors = useCallback(async () => {
    if (!currentUser.admin) {
      setAdminSponsors([]);
      return;
    }
    try {
      setAdminSponsors(await request('/admin/sponsors'));
    } catch {
      setAdminSponsors([]);
    }
  }, [currentUser.admin, request]);

  useEffect(() => {
    loadServers();
    const timer = window.setInterval(loadServers, 15000);
    return () => window.clearInterval(timer);
  }, [loadServers]);

  useEffect(() => {
    loadStats();
    const timer = window.setInterval(loadStats, 30000);
    return () => window.clearInterval(timer);
  }, [loadStats]);

  useEffect(() => {
    loadMe();
    loadSponsors();
  }, [loadMe, loadSponsors]);

  useEffect(() => {
    loadAccountFavorites();
    loadAdminSponsors();
  }, [loadAccountFavorites, loadAdminSponsors]);

  const enrichedServers = useMemo(() => {
    return servers
      .map((server) => enrichServer(server))
      .filter((server) => applyLocalFilters(server, filters, localFlags))
      .sort((a, b) => sortLocal(a, b, filters.sort));
  }, [servers, filters, localFlags]);

  const heroStats = useMemo(() => {
    const onlinePlayers = enrichedServers.reduce((sum, server) => sum + displayPopulation(server).active, 0);
    const justWiped = enrichedServers.filter((server) => server.isJustWiped).length;
    const verified = enrichedServers.filter((server) => hasStrongSource(server)).length;
    const updatedAt = enrichedServers
      .map((server) => dateValue(server.lastChecked || server.lastSuccessfulQuery || server.lastSeen))
      .filter(Boolean)
      .sort((a, b) => b - a)[0];
    return {
      totalServers: stats?.totalServers ?? total,
      onlinePlayers,
      justWiped,
      verified,
      updatedAt
    };
  }, [enrichedServers, stats, total]);

  const sections = useMemo(() => {
    const top = [...enrichedServers].sort((a, b) => b.radarScore - a.radarScore).slice(0, 6);
    const just = enrichedServers.filter((server) => server.isJustWiped).slice(0, 6);
    const duo = enrichedServers.filter((server) => server.groupLimitDetected === 'duo').slice(0, 6);
    const vanilla = enrichedServers.filter((server) => !server.moddedDetected).slice(0, 6);
    const upcoming = [...enrichedServers]
      .filter((server) => server.nextWipeEstimated)
      .sort((a, b) => new Date(a.nextWipeEstimated) - new Date(b.nextWipeEstimated))
      .slice(0, 6);
    return { top, just, duo, vanilla, upcoming };
  }, [enrichedServers]);

  const wipeBuckets = useMemo(() => buildWipeBuckets(enrichedServers), [enrichedServers]);

  const compareServers = useMemo(() => {
    return compareIds.map((id) => enrichedServers.find((server) => server.id === id)).filter(Boolean);
  }, [compareIds, enrichedServers]);

  const clearCompare = () => setCompareIds([]);
  const effectiveFavoriteIds = currentUser.authenticated && !currentUser.admin
    ? accountFavorites.map((server) => server.id)
    : favoriteIds;

  const updateFilter = (key, value) => {
    setFilters((current) => ({ ...current, [key]: value }));
    setLocalFlags((current) => key === 'sort' ? current : { ...current, justWiped: false });
    setPage(0);
  };

  const resetFilters = () => {
    setFilters(defaultFilters);
    setLocalFlags({});
    setSmartQuery('');
    setPage(0);
  };

  const submitSmartSearch = (event) => {
    event.preventDefault();
    const parsed = parseSmartSearch(smartQuery);
    setFilters((current) => ({ ...current, ...parsed.filters, query: smartQuery.trim() }));
    setLocalFlags(parsed.local);
    setPage(0);
  };

  const applyQuickFilter = (chip) => {
    const active = isQuickFilterActive(chip, filters, localFlags);
    setFilters((current) => {
      if (!active) {
        return { ...current, ...chip.patch };
      }
      const next = { ...current };
      Object.keys(chip.patch || {}).forEach((key) => {
        next[key] = defaultFilters[key];
      });
      return next;
    });
    setLocalFlags((current) => {
      const next = active ? { ...current } : { ...current, ...(chip.local || {}) };
      if (active) {
        Object.keys(chip.local || {}).forEach((key) => {
          delete next[key];
        });
      }
      return next;
    });
    setPage(0);
  };

  const openDetails = async (server) => {
    try {
      const [profile, history, wipeHistory] = await Promise.all([
        request(`/servers/${server.id}`),
        request(`/servers/${server.id}/snapshots`),
        request(`/servers/${server.id}/wipes`)
      ]);
      setSelected(enrichServer(profile));
      setSnapshots(history || []);
      setWipes(wipeHistory || []);
    } catch {
      setSelected(server);
      setSnapshots([]);
      setWipes([]);
    }
  };

  const copyText = async (value, message = t.copied) => {
    await navigator.clipboard?.writeText(value);
    setToast(message);
    window.setTimeout(() => setToast(''), 1600);
  };

  const toggleCompare = (server) => {
    setCompareIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current].slice(0, 4);
    });
  };

  const toggleFavorite = async (server) => {
    if (currentUser.authenticated && !currentUser.admin) {
      const exists = accountFavorites.some((favorite) => favorite.id === server.id);
      try {
        if (exists) {
          await request(`/me/favorites/${server.id}`, { method: 'DELETE' });
          setAccountFavorites((current) => current.filter((favorite) => favorite.id !== server.id));
          setToast(t.favoriteRemoved);
        } else {
          const saved = await request(`/me/favorites/${server.id}`, { method: 'POST' });
          setAccountFavorites((current) => [enrichServer(saved), ...current.filter((favorite) => favorite.id !== server.id)]);
          setToast(t.favoriteSaved);
        }
        window.setTimeout(() => setToast(''), 1600);
      } catch {
        setToast(t.quietError);
        window.setTimeout(() => setToast(''), 1600);
      }
      return;
    }
    setFavoriteIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current];
    });
    if (!currentUser.authenticated) {
      setToast(t.loginRequiredFavorite);
      window.setTimeout(() => setToast(''), 2200);
    }
  };

  const saveAlert = () => {
    const alerts = readJson('rustRadarAlerts', []);
    const next = [{ id: Date.now(), query: smartQuery, filters, createdAt: new Date().toISOString() }, ...alerts].slice(0, 20);
    localStorage.setItem('rustRadarAlerts', JSON.stringify(next));
    setAlertOpen(false);
    setToast(t.savedAlert);
  };

  const navigateLanding = (item) => {
    window.history.pushState({}, '', item.path);
    setRoutePath(item.path);
    setFilters((current) => ({ ...current, ...item.patch }));
    setLocalFlags(item.local || {});
    setPage(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goPath = (path) => {
    window.history.pushState({}, '', path);
    setRoutePath(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const steamLogin = () => {
    window.location.href = `${API_BASE}/auth/steam/login`;
  };

  const logout = async () => {
    await request('/auth/logout', { method: 'POST' });
    setCurrentUser({ authenticated: false, admin: false, adminVisible: false });
    setAccountFavorites([]);
    setAdminSponsors([]);
    setToast(t.logout);
    window.setTimeout(() => setToast(''), 1600);
  };

  const adminLogin = async (event) => {
    event.preventDefault();
    try {
      const me = await request('/auth/admin/login', { method: 'POST', body: JSON.stringify({ password: adminPassword }) });
      setCurrentUser(me);
      setAdminPassword('');
      setToast(t.adminLogin);
      window.setTimeout(() => setToast(''), 1600);
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const saveSponsor = async (event) => {
    event.preventDefault();
    const payload = sponsorPayload(sponsorDraft);
    try {
      if (sponsorDraft.id) {
        await request(`/admin/sponsors/${sponsorDraft.id}`, { method: 'PUT', body: JSON.stringify(payload) });
      } else {
        await request('/admin/sponsors', { method: 'POST', body: JSON.stringify(payload) });
      }
      setSponsorDraft(emptySponsorDraft());
      await loadAdminSponsors();
      await loadSponsors();
      setToast(t.saveSponsor);
      window.setTimeout(() => setToast(''), 1600);
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const deleteSponsor = async (id) => {
    try {
      await request(`/admin/sponsors/${id}`, { method: 'DELETE' });
      await loadAdminSponsors();
      await loadSponsors();
    } catch {
      setToast(t.quietError);
      window.setTimeout(() => setToast(''), 1800);
    }
  };

  const pagePath = routePath;
  const isAdminPage = pagePath === '/admin' && currentUser.adminVisible;
  const isAccountPage = pagePath === '/account';

  return (
    <div className="productShell">
      <header className="siteHeader">
        <a className="brandLockup" href="/" onClick={(event) => { event.preventDefault(); resetFilters(); goPath('/'); }}>
          <span className="brandGlyph">R</span>
          <span>
            <strong>Rust Radar</strong>
            <small>Server Intelligence</small>
          </span>
        </a>
        <nav className="topNav" aria-label="Main">
          <a href="#search">{t.navSearch}</a>
          <button type="button" onClick={() => navigateLanding(landingPages.find((item) => item.path === (lang === 'en' ? '/en/just-wiped-rust-servers' : lang === 'ru' ? '/ru/wipes' : '/de/wipes')) || landingPages[0])}>{t.navWipes}</button>
          <button type="button" onClick={() => setCompareOpen(true)}>{t.navCompare} <span>{compareIds.length}</span></button>
          <button type="button" onClick={() => goPath('/account')}>{t.account}</button>
          {currentUser.adminVisible && <button type="button" onClick={() => goPath('/admin')}>{t.admin}</button>}
        </nav>
        <div className="languageSwitch" aria-label="Language">
          {currentUser.authenticated ? (
            <button type="button" onClick={logout}>{t.logout}</button>
          ) : (
            <button type="button" onClick={steamLogin}>{t.loginSteam}</button>
          )}
          {LANGS.map((code) => (
            <button className={code === lang ? 'active' : ''} key={code} type="button" onClick={() => setLang(code)}>
              {code.toUpperCase()}
            </button>
          ))}
        </div>
      </header>

      <main>
        {isAdminPage ? (
          <AdminPage
            t={t}
            currentUser={currentUser}
            adminPassword={adminPassword}
            setAdminPassword={setAdminPassword}
            onLogin={adminLogin}
            sponsors={adminSponsors}
            draft={sponsorDraft}
            setDraft={setSponsorDraft}
            onSave={saveSponsor}
            onDelete={deleteSponsor}
          />
        ) : isAccountPage ? (
          <AccountPage
            t={t}
            currentUser={currentUser}
            favorites={accountFavorites}
            onSteamLogin={steamLogin}
            onOpen={openDetails}
            onCopy={copyText}
          />
        ) : (
          <>
        <section className="heroSection" id="search">
          <div className="heroContent">
            <p className="eyebrow">{t.heroEyebrow}</p>
            <h1>{t.heroTitle}</h1>
            <p className="heroCopy">{t.heroCopy}</p>
            <form className="smartSearch" onSubmit={submitSmartSearch}>
              <span className="searchIcon">⌕</span>
              <input value={smartQuery} onChange={(event) => setSmartQuery(event.target.value)} placeholder={t.searchPlaceholder} />
              <button type="submit">{t.searchButton}</button>
            </form>
            <div className="quickChips" aria-label={t.quickFilters}>
              {quickFilters.map((chip) => (
                <button
                  className={isQuickFilterActive(chip, filters, localFlags) ? 'active' : ''}
                  key={chip.id}
                  type="button"
                  onClick={() => applyQuickFilter(chip)}
                >
                  {chip.labelKey ? t[chip.labelKey] : chip.label}
                </button>
              ))}
            </div>
          </div>
          <div className="heroStats">
            <Metric value={heroStats.totalServers} label={t.liveServers} />
            <Metric value={heroStats.onlinePlayers} label={t.playersOnline} />
            <Metric value={heroStats.justWiped} label={t.justWiped} />
            <Metric value={heroStats.verified} label={t.verifiedServers} meta={heroStats.updatedAt ? `${t.updatedAgo}: ${formatRelativePast(heroStats.updatedAt, t)}` : ''} />
          </div>
        </section>

        <SponsorStrip sponsors={sponsors} t={t} />

        <section className="filterDock">
          <div className="filterDockHeader">
            <div>
              <strong>{t.quickFilters}</strong>
              <span>{formatNumber(enrichedServers.length)} / {formatNumber(total)} {t.servers}</span>
            </div>
            <div className="filterActions">
              <button type="button" onClick={() => setShowFilters((value) => !value)}>{showFilters ? t.hideFilters : t.allFilters}</button>
              <button type="button" onClick={resetFilters}>{t.resetFilters}</button>
            </div>
          </div>
          <div className="primaryFilterGrid">
            <Select label={t.region} value={filters.region} onChange={(value) => updateFilter('region', value)} options={['all', 'EU', 'US', 'NA', 'AU', 'SEA', 'RU']} t={t} />
            <Select label={t.type} value={filters.mode} onChange={(value) => updateFilter('mode', value)} options={['all', 'vanilla', 'modded', 'official', 'pve']} t={t} />
            <Select label={t.team} value={filters.group} onChange={(value) => updateFilter('group', value)} options={['all', 'solo', 'duo', 'trio', 'quad', '5-max', '6-max', 'no-limit']} t={t} />
            <Select label={t.gather} value={filters.gather} onChange={(value) => updateFilter('gather', value)} options={['all', '1x', '1.5x', '2x', '3x', '5x', '10x', '50x', '100x']} t={t} />
            <Select label={t.wipe} value={filters.wipe} onChange={(value) => updateFilter('wipe', value)} options={['all', 'daily', 'weekly', 'biweekly', 'monthly']} t={t} />
            <RangeFilter label={t.playersRange || t.players} min={filters.playersMin} max={filters.playersMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('playersMin', value)} onMax={(value) => updateFilter('playersMax', value)} />
          </div>
          {showFilters && (
            <div className="advancedFilterPanel">
              <div className="filterGroup">
                <strong>{t.quality}</strong>
                <div className="filterGrid">
                  <Select label={t.quality} value={filters.quality} onChange={(value) => updateFilter('quality', value)} options={['all', 'verified', 'high', 'medium']} t={t} />
                  <Select label={t.population} value={filters.population} onChange={(value) => updateFilter('population', value)} options={['all', 'high', 'medium', 'low']} t={t} />
                  <Select label={t.bpWipe} value={filters.bp} onChange={(value) => updateFilter('bp', value)} options={['all', 'no', 'yes', 'unknown']} t={t} />
                  <Select label={t.sort} value={filters.sort} onChange={(value) => updateFilter('sort', value)} options={['radar', 'players', 'wipe', 'fresh', 'confidence']} t={t} />
                </div>
              </div>
              <div className="filterGroup">
                <strong>{t.from} / {t.to}</strong>
                <div className="filterGrid">
                  <RangeFilter label={t.maxPlayersRange || 'Slots'} min={filters.maxPlayersMin} max={filters.maxPlayersMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('maxPlayersMin', value)} onMax={(value) => updateFilter('maxPlayersMax', value)} />
                  <RangeFilter label={t.pingRange || t.ping} min={filters.pingMin} max={filters.pingMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('pingMin', value)} onMax={(value) => updateFilter('pingMax', value)} />
                  <RangeFilter label={t.gatherRange || t.gather} min={filters.gatherMin} max={filters.gatherMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} step="0.5" onMin={(value) => updateFilter('gatherMin', value)} onMax={(value) => updateFilter('gatherMax', value)} />
                  <RangeFilter label={t.teamRange || t.team} min={filters.teamMin} max={filters.teamMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('teamMin', value)} onMax={(value) => updateFilter('teamMax', value)} />
                  <RangeFilter label={t.qualityRange || t.quality} min={filters.qualityMin} max={filters.qualityMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('qualityMin', value)} onMax={(value) => updateFilter('qualityMax', value)} />
                  <RangeFilter label={t.wipeAgeRange || t.lastWipe} min={filters.wipeAgeMin} max={filters.wipeAgeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('wipeAgeMin', value)} onMax={(value) => updateFilter('wipeAgeMax', value)} />
                  <RangeFilter label={t.nextWipeRange || t.nextWipe} min={filters.nextWipeMin} max={filters.nextWipeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} onMin={(value) => updateFilter('nextWipeMin', value)} onMax={(value) => updateFilter('nextWipeMax', value)} />
                  <RangeFilter label={t.mapSizeRange || t.mapSize} min={filters.mapSizeMin} max={filters.mapSizeMax} minLabel={t.from || 'From'} maxLabel={t.to || 'To'} step="100" onMin={(value) => updateFilter('mapSizeMin', value)} onMax={(value) => updateFilter('mapSizeMax', value)} />
                </div>
              </div>
            </div>
          )}
        </section>

        {toast && <div className="toast">{toast}</div>}
        {softError && <div className="softNotice">{t.quietError}</div>}

        {activeLanding && (
          <section className="landingPanel">
            <p className="eyebrow">SEO Live Page</p>
            <h2>{activeLanding.label}</h2>
            <p>{t.landingCopy}</p>
          </section>
        )}

        <WipeHub buckets={wipeBuckets} t={t} onOpen={openDetails} onCopy={copyText} />

        <section className="featureGrid">
          <FeaturePanel title={t.upcomingWipes} servers={sections.upcoming} empty={t.empty} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.justWiped} servers={sections.just} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <ServerSection
          title={t.topServers}
          subtitle={t.footerCopy}
          servers={enrichedServers.length ? enrichedServers : sections.top}
          t={t}
          compareIds={compareIds}
          favoriteIds={effectiveFavoriteIds}
          onOpen={openDetails}
          onCopy={copyText}
          onCompare={toggleCompare}
          onFavorite={toggleFavorite}
          onAlert={(server) => { setSelected(server); setAlertOpen(true); }}
          onReset={resetFilters}
        />

        <section className="featureGrid">
          <FeaturePanel title={t.bestDuo} servers={sections.duo} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.bestVanilla} servers={sections.vanilla} empty={t.emptyFiltered} onReset={resetFilters} t={t} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <section className="seoPanel">
          <div>
            <p className="eyebrow">{t.seoTitle}</p>
            <h2>Rust Server Finder</h2>
          </div>
          <div className="seoLinks">
            {landingPages.map((item) => (
              <button key={item.path} type="button" onClick={() => navigateLanding(item)}>{item.label}</button>
            ))}
          </div>
        </section>
          </>
        )}
      </main>

      {compareIds.length > 0 && (
        <div className="compareBar">
          <strong>{compareIds.length} {t.compareSelected}</strong>
          <div>
            <button type="button" onClick={() => setCompareOpen(true)}>{t.openCompare}</button>
            <button type="button" onClick={clearCompare}>{t.clear}</button>
          </div>
        </div>
      )}

      {selected && !alertOpen && (
        <DetailDrawer
          server={selected}
          snapshots={snapshots}
          wipes={wipes}
          t={t}
          onClose={() => setSelected(null)}
          onCopy={copyText}
          onAlert={() => setAlertOpen(true)}
        />
      )}

      {compareOpen && (
        <CompareDrawer
          servers={compareServers}
          t={t}
          onClose={() => setCompareOpen(false)}
          onRemove={(server) => toggleCompare(server)}
        />
      )}

      {alertOpen && (
        <AlertDialog
          t={t}
          server={selected}
          filters={filters}
          query={smartQuery}
          onClose={() => setAlertOpen(false)}
          onSave={saveAlert}
        />
      )}
    </div>
  );
}

function ServerSection({ title, subtitle, servers, t, compareIds, favoriteIds, onOpen, onCopy, onCompare, onFavorite, onAlert, onReset }) {
  const visible = servers.slice(0, 18);
  return (
    <section className="serverSection">
      <div className="sectionHeader">
        <div>
          <p className="eyebrow">{t.recommended}</p>
          <h2>{title}</h2>
          <span>{subtitle}</span>
        </div>
      </div>
      {visible.length === 0 && <EmptyState text={t.emptyFiltered} t={t} onReset={onReset} />}
      <div className="serverList">
        {visible.map((server) => (
          <ServerCard
            key={server.id}
            server={server}
            t={t}
            isCompared={compareIds.includes(server.id)}
            isFavorite={favoriteIds.includes(server.id)}
            onOpen={onOpen}
            onCopy={onCopy}
            onCompare={onCompare}
            onFavorite={onFavorite}
            onAlert={onAlert}
          />
        ))}
      </div>
    </section>
  );
}

function ServerCard({ server, t, isCompared, isFavorite, onOpen, onCopy, onCompare, onFavorite, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const population = displayPopulation(server);
  const bp = detectBpWipe(server);
  return (
    <article className="serverCard">
      <div className="serverMain">
        <div className="titleRow">
          <h3 title={server.name || endpoint}>{server.name || endpoint}</h3>
          <button className={`starButton ${isFavorite ? 'active' : ''}`} type="button" onClick={() => onFavorite(server)} aria-label={t.favorite}>★</button>
        </div>
        <div className="serverMeta">
          <span>{endpoint}</span>
          <span>{server.region || t.unknown}</span>
          <span>{server.mapName || t.map}</span>
        </div>
        <div className="tagRow">
          <Badge text={server.online ? t.online : t.offline} tone={server.online ? 'green' : 'red'} />
          <Badge text={server.moddedDetected ? t.modded : t.vanilla} tone={server.moddedDetected ? 'orange' : 'green'} />
          {server.official && <Badge text={t.official} tone="blue" />}
          {server.groupLimitDetected && <Badge text={server.groupLimitDetected} tone="blue" />}
          {server.gatherRateDetected && <Badge text={server.gatherRateDetected} tone="orange" />}
          {server.wipeCycleDetected && <Badge text={server.wipeCycleDetected} tone="purple" />}
          {bp.value !== 'unknown' && <Badge text={`${t.bpWipe}: ${bp.label(t)}`} tone={bp.value === 'no' ? 'green' : 'yellow'} />}
          <Badge text={`${t.dataQuality}: ${server.dataQuality}%`} tone={server.dataQuality >= 85 ? 'green' : server.dataQuality >= 65 ? 'yellow' : 'red'} />
        </div>
      </div>

      <div className="decisionGrid">
        <Info label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
        <Info label={population.queue > 0 ? t.queue : t.ping} value={population.queue > 0 ? formatNumber(population.queue) : (server.pingMs ? `${server.pingMs} ms` : t.unknown)} accent={population.queue > 0} />
        <Info label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} accent={server.isJustWiped} />
        <Info label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
        <Info label={t.team} value={server.groupLimitDetected || t.unknown} />
        <Info label={t.gather} value={server.gatherRateDetected || '1x'} />
        <Info label={t.bpWipe} value={bp.label(t)} />
        <Info label={t.mapSize} value={server.worldSize || t.unknown} />
      </div>

      <div className="scorePanel">
        <div className="scoreRing" style={{ '--score': `${server.radarScore}%` }}>
          <strong>{server.radarScore}</strong>
          <small>{t.ranking}</small>
        </div>
        <div className="popBar">
          <span style={{ width: `${population.ratio}%` }} />
        </div>
        <small>{t.source}: {sourceLabel(server, t)}</small>
        <div className="scoreReasons">
          {(server.scoreReasons || []).slice(0, 3).map((reason) => <span key={reason}>{t[reason] || reason}</span>)}
        </div>
        {server.dataWarnings?.length > 0 && (
          <div className="dataWarnings">
            {server.dataWarnings.slice(0, 2).map((warning) => <span key={warning}>{t[warning] || warning}</span>)}
          </div>
        )}
      </div>

      <div className="cardActions">
        <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
        <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
        <button type="button" onClick={() => onOpen(server)}>{t.details}</button>
        <button className={isCompared ? 'activeAction' : ''} type="button" onClick={() => onCompare(server)}>{t.compare}</button>
        <button type="button" onClick={() => onAlert(server)}>{t.alert}</button>
      </div>
    </article>
  );
}

function DetailDrawer({ server, snapshots, wipes, t, onClose, onCopy, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const rules = Object.entries(server.rules || {}).slice(0, 80);
  const bp = detectBpWipe(server);
  const population = displayPopulation(server);
  return (
    <aside className="drawerOverlay">
      <div className="detailDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.profile}</p>
            <h2>{server.name || endpoint}</h2>
            <span>{endpoint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>

        <div className="drawerActions">
          <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
          <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
          <button type="button" onClick={onAlert}>{t.alert}</button>
        </div>

        <div className="drawerBody">
          <section>
            <h3>{t.overview}</h3>
            <div className="kvGrid">
              <Kv label={t.fullName} value={server.name || '-'} />
              <Kv label={t.endpoint} value={endpoint} />
              <Kv label={t.status} value={server.online ? t.online : t.offline} />
              <Kv label={t.mode} value={server.official ? t.official : server.moddedDetected ? t.modded : t.vanilla} />
              <Kv label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
              {population.queue > 0 && <Kv label={t.queue} value={formatNumber(population.queue)} />}
              <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
              <Kv label={t.region} value={server.region || t.unknown} />
              <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
              <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
              <Kv label={t.bpWipe} value={bp.label(t)} />
              <Kv label={`${t.bpWipe} ${t.source}`} value={bp.source || t.unknown} />
              <Kv label={`${t.bpWipe} ${t.confidence}`} value={bp.confidence || t.uncertain} />
              <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
              <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
              <Kv label={t.map} value={server.mapName || t.unknown} />
              <Kv label={t.mapSize} value={server.worldSize || t.unknown} />
              <Kv label={`${t.mapSize} ${t.source}`} value={server.mapSizeSource || t.unknown} />
              <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
              <Kv label={t.source} value={sourceLabel(server, t)} />
              <Kv label={t.ownerStatus} value={t.notClaimed} />
            </div>
          </section>

          <section>
            <h3>{t.scoreBreakdown}</h3>
            <ScoreBreakdown server={server} t={t} />
          </section>

          <section>
            <h3>{t.history}</h3>
            <HistoryBars snapshots={snapshots} t={t} />
          </section>

          <section>
            <h3>{t.wipeHistory}</h3>
            {wipes.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            <div className="wipeList">
              {wipes.map((wipe) => (
                <Kv key={`${wipe.detectedAt}-${wipe.detectedBy}`} label={wipe.detectedBy || t.historyEstimated} value={`${wipe.type || t.unknown} · ${Math.round((wipe.confidence || 0) * 100)}% · ${formatDate(wipe.detectedAt, true) || '-'}`} />
              ))}
            </div>
          </section>

          <section>
            <h3>{t.rules}</h3>
            {rules.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            {rules.length > 0 && (
              <table className="rulesTable">
                <tbody>
                  {rules.map(([key, value]) => <tr key={key}><td>{key}</td><td>{value}</td></tr>)}
                </tbody>
              </table>
            )}
          </section>
        </div>
      </div>
    </aside>
  );
}

function CompareDrawer({ servers, t, onClose, onRemove }) {
  return (
    <aside className="drawerOverlay">
      <div className="compareDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.navCompare}</p>
            <h2>{t.compareServers}</h2>
            <span>{t.compareHint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        {servers.length === 0 && <div className="emptyState">{t.compareHint}</div>}
        {servers.length > 0 && (
          <div className="compareGrid">
            {servers.map((server) => (
              <CompareCard key={server.id} server={server} t={t} onRemove={onRemove} />
            ))}
          </div>
        )}
      </div>
    </aside>
  );
}

function AlertDialog({ t, server, filters, query, onClose, onSave }) {
  return (
    <aside className="drawerOverlay">
      <div className="alertDialog">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.alert}</p>
            <h2>{t.createAlert}</h2>
            <span>{server?.name || query || t.heroTitle}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        <p>{t.alertCopy}</p>
        <div className="kvGrid">
          <Kv label={t.region} value={filters.region} />
          <Kv label={t.team} value={filters.group} />
          <Kv label={t.gather} value={filters.gather} />
          <Kv label={t.wipe} value={filters.wipe} />
        </div>
        <button className="connectButton wide" type="button" onClick={onSave}>{t.saveAlert}</button>
      </div>
    </aside>
  );
}

function SponsorStrip({ sponsors, t }) {
  if (!sponsors.length) {
    return null;
  }
  return (
    <section className="sponsorStrip">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">{t.sponsored}</p>
          <h2>{t.sponsorLive}</h2>
          <span>{t.sponsorCopy}</span>
        </div>
      </div>
      <div className="sponsorGrid">
        {sponsors.slice(0, 3).map((sponsor) => (
          <a className="sponsorCard" href={sponsor.targetUrl || '#'} target={sponsor.targetUrl ? '_blank' : undefined} rel="noreferrer" key={sponsor.id}>
            {sponsor.imageUrl && <img src={sponsor.imageUrl} alt="" />}
            <span className="badge orange">{t.sponsored}</span>
            <strong>{sponsor.title || t.sponsored}</strong>
            <small>{sponsor.description || sponsor.targetUrl}</small>
          </a>
        ))}
      </div>
    </section>
  );
}

function AccountPage({ t, currentUser, favorites, onSteamLogin, onOpen, onCopy }) {
  if (!currentUser.authenticated || currentUser.admin) {
    return (
      <section className="accountPage">
        <p className="eyebrow">{t.account}</p>
        <h1>{t.loginSteam}</h1>
        <p>{t.steamLoginCopy}</p>
        <button className="connectButton" type="button" onClick={onSteamLogin}>{t.loginSteam}</button>
      </section>
    );
  }
  return (
    <section className="accountPage">
      <p className="eyebrow">{t.account}</p>
      <div className="accountHeader">
        {currentUser.avatarUrl && <img src={currentUser.avatarUrl} alt="" />}
        <div>
          <h1>{t.signedInAs} {currentUser.displayName || currentUser.steamId}</h1>
          <span>{currentUser.steamId}</span>
        </div>
      </div>
      <h2>{t.favorites}</h2>
      {favorites.length === 0 && <div className="emptyState">{t.noFavorites}</div>}
      <div className="accountFavorites">
        {favorites.map((server) => {
          const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
          return (
            <div className="favoriteAccountCard" key={server.id}>
              <MiniServer server={server} t={t} onOpen={onOpen} />
              <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function AdminPage({ t, currentUser, adminPassword, setAdminPassword, onLogin, sponsors, draft, setDraft, onSave, onDelete }) {
  if (!currentUser.admin) {
    return (
      <section className="adminPage">
        <p className="eyebrow">{t.admin}</p>
        <h1>{t.adminLogin}</h1>
        <p>{t.adminHint}</p>
        <form className="adminLoginForm" onSubmit={onLogin}>
          <label>
            <span>{t.adminPassword}</span>
            <input type="password" value={adminPassword} onChange={(event) => setAdminPassword(event.target.value)} />
          </label>
          <button className="connectButton" type="submit">{t.login}</button>
        </form>
      </section>
    );
  }

  return (
    <section className="adminPage">
      <p className="eyebrow">{t.adminPanel}</p>
      <h1>{t.sponsorAdmin}</h1>
      <p>{t.adminHint}</p>
      <form className="sponsorForm" onSubmit={onSave}>
        <div className="formHeader">
          <h2>{draft.id ? draft.title || t.sponsorAdmin : t.newSponsor}</h2>
          <button type="button" onClick={() => setDraft(emptySponsorDraft())}>{t.newSponsor}</button>
        </div>
        <label><span>{t.sponsorTitle}</span><input value={draft.title} onChange={(event) => setDraft({ ...draft, title: event.target.value })} /></label>
        <label><span>{t.sponsorDescription}</span><textarea value={draft.description} onChange={(event) => setDraft({ ...draft, description: event.target.value })} /></label>
        <div className="formGrid">
          <label><span>{t.sponsorImage}</span><input value={draft.imageUrl} onChange={(event) => setDraft({ ...draft, imageUrl: event.target.value })} /></label>
          <label><span>{t.sponsorTarget}</span><input value={draft.targetUrl} onChange={(event) => setDraft({ ...draft, targetUrl: event.target.value })} /></label>
          <label><span>{t.sponsorPlacement}</span><input value={draft.placement} onChange={(event) => setDraft({ ...draft, placement: event.target.value })} /></label>
          <label><span>{t.sponsorServerId}</span><input type="number" min="0" value={draft.serverId} onChange={(event) => setDraft({ ...draft, serverId: event.target.value })} /></label>
          <label><span>{t.sponsorPriority}</span><input type="number" value={draft.priority} onChange={(event) => setDraft({ ...draft, priority: event.target.value })} /></label>
          <label><span>{t.sponsorStarts}</span><input type="datetime-local" value={draft.startsAt} onChange={(event) => setDraft({ ...draft, startsAt: event.target.value })} /></label>
          <label><span>{t.sponsorEnds}</span><input type="datetime-local" value={draft.endsAt} onChange={(event) => setDraft({ ...draft, endsAt: event.target.value })} /></label>
          <label className="checkLabel"><input type="checkbox" checked={draft.active} onChange={(event) => setDraft({ ...draft, active: event.target.checked })} /><span>{t.sponsorActive}</span></label>
        </div>
        <button className="connectButton wide" type="submit">{t.saveSponsor}</button>
      </form>

      <section className="sponsorListAdmin">
        <h2>{t.currentSponsors}</h2>
        {sponsors.length === 0 && <div className="emptyState compact">{t.empty}</div>}
        {sponsors.map((sponsor) => (
          <div className="adminSponsorRow" key={sponsor.id}>
            <div>
              <strong>{sponsor.title}</strong>
              <span>{sponsor.placement} · {sponsor.active ? t.online : t.offline} · #{sponsor.priority}</span>
            </div>
            <div>
              <button type="button" onClick={() => setDraft(draftFromSponsor(sponsor))}>{t.details}</button>
              <button type="button" onClick={() => window.confirm(`${t.deleteSponsor}?`) && onDelete(sponsor.id)}>{t.deleteSponsor}</button>
            </div>
          </div>
        ))}
      </section>
    </section>
  );
}

function WipeHub({ buckets, t, onOpen, onCopy }) {
  return (
    <section className="wipeHub" id="wipes">
      <div className="panelHeader">
        <div>
          <p className="eyebrow">Wipe Intelligence</p>
          <h2>{t.justWiped}</h2>
          <span>{t.wipeHubCopy}</span>
        </div>
      </div>
      <div className="wipeBuckets">
        {buckets.map((bucket) => (
          <div className="wipeBucket" key={bucket.key}>
            <div className="wipeBucketHeader">
              <strong>{t[bucket.label] || bucket.label}</strong>
              <span>{bucket.servers.length}</span>
            </div>
            {bucket.servers.length === 0 && <div className="emptyState compact">{t.empty}</div>}
            {bucket.servers.map((server) => {
              const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
              const population = displayPopulation(server);
              return (
                <div className="wipeItem" key={`${bucket.key}-${server.id}`}>
                  <button type="button" onClick={() => onOpen(server)}>
                    <strong>{server.name || endpoint}</strong>
                    <small>{formatRelative(server.lastWipeDetected, t)} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'} · {formatNumber(population.active)}/{formatNumber(population.max)}</small>
                  </button>
                  <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
}

function ScoreBreakdown({ server, t }) {
  const parts = server.scoreParts || {};
  const rows = [
    [t.scoreWipe, parts.wipe],
    [t.scorePopulation, parts.population],
    [t.scoreQuality, parts.quality],
    [t.scorePing, parts.ping],
    [t.scoreStatus, parts.status]
  ];
  return (
    <div className="scoreBreakdown">
      <div className="scoreTotal">
        <strong>{server.radarScore}</strong>
        <span>{t.ranking}</span>
      </div>
      <div className="scoreRows">
        {rows.map(([label, value]) => (
          <div className="scoreRow" key={label}>
            <span>{label}</span>
            <div><i style={{ width: `${Math.max(0, Math.min(100, value || 0))}%` }} /></div>
            <strong>{Math.round(value || 0)}</strong>
          </div>
        ))}
      </div>
      <div className="scoreReasons wide">
        {(server.scoreReasons || []).map((reason) => <span key={reason}>{t[reason] || reason}</span>)}
      </div>
      {server.dataWarnings?.length > 0 && (
        <div className="dataWarnings wide">
          {server.dataWarnings.map((warning) => <span key={warning}>{t[warning] || warning}</span>)}
        </div>
      )}
      <p className="sourceNote">{t.ownerVerifiedOnly}</p>
    </div>
  );
}

function CompareCard({ server, t, onRemove }) {
  const population = displayPopulation(server);
  return (
    <div className="compareCard">
      <button type="button" onClick={() => onRemove(server)}>{t.remove}</button>
      <h3>{server.name}</h3>
      <Kv label={t.players} value={`${formatNumber(population.active)} / ${formatNumber(population.max)}`} />
      {population.queue > 0 && <Kv label={t.queue} value={formatNumber(population.queue)} />}
      <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
      <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
      <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
      <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
      <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
      <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
      <Kv label={t.ranking} value={server.radarScore} />
      <Kv label={t.source} value={sourceLabel(server, t)} />
    </div>
  );
}

function EmptyState({ text, t, onReset, compact }) {
  return (
    <div className={`emptyState ${compact ? 'compact' : ''}`}>
      <span>{text}</span>
      {onReset && (
        <div className="emptyActions">
          <button type="button" onClick={onReset}>{t.resetFilters}</button>
        </div>
      )}
    </div>
  );
}

function FeaturePanel({ title, servers, empty, render, t, onReset }) {
  return (
    <section className="featurePanel">
      <div className="panelHeader">
        <h2>{title}</h2>
      </div>
      {servers.length === 0 ? <EmptyState compact text={empty} t={t} onReset={onReset} /> : <div className="miniList">{servers.map(render)}</div>}
    </section>
  );
}

function MiniServer({ server, t, onOpen }) {
  const population = displayPopulation(server);
  return (
    <button className="miniServer" type="button" onClick={() => onOpen(server)}>
      <span>
        <strong>{server.name}</strong>
        <small>{server.region || t.unknown} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'}</small>
      </span>
      <em>{formatNumber(population.active)}/{formatNumber(population.max)}{population.queue > 0 ? ` +${formatNumber(population.queue)}` : ''}</em>
    </button>
  );
}

function HistoryBars({ snapshots, t }) {
  if (!snapshots.length) {
    return <div className="emptyState compact">{t.noHistory}</div>;
  }
  return (
    <div className="historyBars">
      {snapshots.slice(0, 24).map((snapshot) => (
        <div className="historyRow" key={snapshot.capturedAt}>
          <span>{formatDate(snapshot.capturedAt, true) || '-'}</span>
          <div className="bar"><i style={{ width: `${displayPopulation(snapshot).ratio}%` }} /></div>
          <strong>{displayPopulation(snapshot).active || 0}/{displayPopulation(snapshot).max || 0}</strong>
        </div>
      ))}
    </div>
  );
}

function Select({ label, value, options, onChange, t }) {
  return (
    <label>
      <span>{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => <option key={option} value={option}>{optionLabel(option, t)}</option>)}
      </select>
    </label>
  );
}

function RangeFilter({ label, min, max, minLabel, maxLabel, onMin, onMax, step = '1' }) {
  return (
    <label className="rangeFilter">
      <span>{label}</span>
      <div className="rangeInputs">
        <input type="number" inputMode="decimal" min="0" step={step} value={min} onChange={(event) => onMin(event.target.value)} placeholder={minLabel} />
        <input type="number" inputMode="decimal" min="0" step={step} value={max} onChange={(event) => onMax(event.target.value)} placeholder={maxLabel} />
      </div>
    </label>
  );
}

function Metric({ value, label, meta }) {
  return (
    <div className="metricCard">
      <strong>{formatNumber(value)}</strong>
      <span>{label}</span>
      {meta && <small>{meta}</small>}
    </div>
  );
}

function Info({ label, value, accent }) {
  return (
    <div className={`infoCell ${accent ? 'accent' : ''}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function Kv({ label, value }) {
  return <div className="kv"><span>{label}</span><strong>{String(value ?? '-')}</strong></div>;
}

function Badge({ text, tone }) {
  return <span className={`badge ${tone || ''}`}>{text}</span>;
}

function enrichServer(server) {
  const dataQuality = Math.round((server.confidenceScore || 0.45) * 100);
  const radar = calculateRadarScore(server, dataQuality);
  const wipeAge = ageMinutes(server.lastWipeDetected);
  const isJustWiped = wipeAge !== null && wipeAge < 1440;
  return {
    ...server,
    dataQuality,
    radarScore: radar.total,
    scoreParts: radar.parts,
    scoreReasons: radar.reasons,
    dataWarnings: radar.warnings,
    isJustWiped
  };
}

function calculateRadarScore(server, dataQuality) {
  const population = displayPopulation(server);
  const wipeAge = ageMinutes(server.lastWipeDetected);
  const wipe = wipeAge === null ? 20 : Math.max(25, 100 - Math.floor(wipeAge / 18));
  const ping = server.pingMs ? Math.max(10, 100 - Math.floor(server.pingMs * 0.9)) : 45;
  const status = server.online ? 100 : 10;
  const parts = {
    wipe,
    population: population.ratio,
    quality: dataQuality,
    ping,
    status
  };
  const warnings = [];
  const reasons = [];

  if (wipeAge !== null && wipeAge <= 180) reasons.push('freshWipe');
  if (population.active >= 30 && population.ratio <= 98) reasons.push('stablePop');
  if (hasStrongSource({ ...server, dataQuality })) reasons.push('strongData');
  if (detectBpWipe(server).value === 'unknown') reasons.push('bpUnclear');
  if (population.queue > 0) warnings.push('queueDetected');
  if (population.raw > 0 && population.max > 0 && population.raw > population.max * 1.25) warnings.push('fakeRiskHigh');
  else if (population.queue > 0 || dataQuality < 55) warnings.push('fakeRiskMedium');
  else warnings.push('fakeRiskLow');

  const score = Math.round((parts.wipe * 0.22) + (parts.population * 0.22) + (parts.quality * 0.28) + (parts.ping * 0.14) + (parts.status * 0.14));
  return {
    total: Math.max(1, Math.min(99, score)),
    parts,
    reasons,
    warnings
  };
}

function applyLocalFilters(server, filters, localFlags) {
  if (localFlags.justWiped && !server.isJustWiped) return false;
  const population = displayPopulation(server);
  if (!inRange(population.active, filters.playersMin || filters.minPlayers, filters.playersMax)) return false;
  if (!inRange(server.maxPlayers, filters.maxPlayersMin, filters.maxPlayersMax)) return false;
  if (!inRange(server.pingMs, filters.pingMin, filters.pingMax)) return false;
  if (!inRange(parseRateValue(server.gatherRateDetected), filters.gatherMin, filters.gatherMax)) return false;
  if (!inRange(parseTeamValue(server.groupLimitDetected), filters.teamMin, filters.teamMax)) return false;
  if (!inRange(server.dataQuality, filters.qualityMin, filters.qualityMax)) return false;
  if (!inRange(server.worldSize, filters.mapSizeMin, filters.mapSizeMax)) return false;
  if (!inRange(ageMinutes(server.lastWipeDetected), filters.wipeAgeMin, filters.wipeAgeMax)) return false;
  if (!inRange(hoursUntil(server.nextWipeEstimated), filters.nextWipeMin, filters.nextWipeMax)) return false;
  if (filters.quality === 'verified' && server.dataQuality < 90) return false;
  if (filters.quality === 'high' && server.dataQuality < 75) return false;
  if (filters.quality === 'medium' && server.dataQuality < 55) return false;
  if (filters.population === 'high' && population.active < 100) return false;
  if (filters.population === 'medium' && (population.active < 30 || population.active >= 100)) return false;
  if (filters.population === 'low' && population.active >= 30) return false;
  if (filters.lowPing && (!server.pingMs || server.pingMs > 80)) return false;
  if (filters.bp !== 'all' && detectBpWipe(server).value !== filters.bp) return false;
  return true;
}

function inRange(value, min, max) {
  const hasMin = hasValue(min) && Number(min) > 0;
  const hasMax = hasValue(max) && Number(max) > 0;
  if (!hasMin && !hasMax) return true;
  if (value === undefined || value === null || Number.isNaN(Number(value))) return false;
  const numeric = Number(value);
  if (hasMin && numeric < Number(min)) return false;
  if (hasMax && numeric > Number(max)) return false;
  return true;
}

function parseRateValue(value) {
  if (!value) return null;
  const match = String(value).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
  return match ? Number(match[1]) : null;
}

function parseTeamValue(value) {
  if (!value) return null;
  const text = String(value).toLowerCase();
  if (text.includes('solo')) return 1;
  if (text.includes('duo')) return 2;
  if (text.includes('trio')) return 3;
  if (text.includes('quad')) return 4;
  if (text.includes('no-limit') || text.includes('nolimit') || text.includes('unlimited') || text.includes('clan')) return 999;
  const match = text.match(/\d+/);
  return match ? Number(match[0]) : null;
}

function ageMinutes(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const diff = Date.now() - date.getTime();
  if (diff < -5 * 60000) return null;
  return Math.max(0, Math.floor(diff / 60000));
}

function hoursUntil(value) {
  if (!value) return null;
  return Math.max(0, Math.ceil((new Date(value).getTime() - Date.now()) / 3600000));
}

function sortLocal(a, b, sort) {
  if (sort === 'radar') return b.radarScore - a.radarScore;
  if (sort === 'players') return displayPopulation(b).active - displayPopulation(a).active;
  if (sort === 'wipe') return dateValue(b.lastWipeDetected) - dateValue(a.lastWipeDetected);
  if (sort === 'fresh') return dateValue(b.lastSuccessfulQuery) - dateValue(a.lastSuccessfulQuery);
  if (sort === 'confidence') return b.dataQuality - a.dataQuality;
  return b.radarScore - a.radarScore;
}

function parseSmartSearch(query) {
  const value = query.toLowerCase();
  const filters = {};
  const local = {};

  if (/\beu\b/.test(value)) filters.region = 'EU';
  if (/\b(us|usa)\b/.test(value)) filters.region = 'US';
  if (/\b(na)\b/.test(value)) filters.region = 'NA';
  if (/\b(au)\b/.test(value)) filters.region = 'AU';
  if (/\b(ru|russian|рус|русский)\b/.test(value)) filters.region = 'RU';

  if (/\bsolo\b|соло/.test(value)) filters.group = 'solo';
  if (/\bduo\b|дуо/.test(value)) filters.group = 'duo';
  if (/\btrio\b|трио/.test(value)) filters.group = 'trio';
  if (/\bquad\b/.test(value)) filters.group = 'quad';

  const rate = value.match(/\b(1\.5|1,5|2|3|5|10|50|100)\s*x\b/);
  if (rate) filters.gather = `${rate[1].replace(',', '.')}x`;

  if (/vanilla/.test(value)) filters.mode = 'vanilla';
  if (/modded|oxide|carbon|kits|tp|teleport|shop|мод/.test(value)) filters.mode = 'modded';
  if (/\bpve\b|зомби|zombies/.test(value)) filters.mode = 'pve';
  if (/official|facepunch/.test(value)) filters.mode = 'official';

  if (/weekly/.test(value)) filters.wipe = 'weekly';
  if (/biweekly|bi-weekly/.test(value)) filters.wipe = 'biweekly';
  if (/monthly/.test(value)) filters.wipe = 'monthly';
  if (/daily/.test(value)) filters.wipe = 'daily';
  if (/wiped today|just wiped|fresh wipe|gerade gewiped|недавний вайп|вайп/.test(value)) {
    filters.sort = 'wipe';
    local.justWiped = true;
  }
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(value)) {
    filters.bp = 'no';
  }
  if (/high pop|full|voll/.test(value)) filters.population = 'high';
  if (/low pop|empty|leer/.test(value)) filters.population = 'low';
  if (/low ping|ping/.test(value)) filters.lowPing = true;

  return { filters, local };
}

function detectBpWipe(server) {
  if (server.bpWipeDetected && server.bpWipeDetected !== 'unknown') {
    const value = server.bpWipeDetected;
    return {
      value,
      confidence: server.bpWipeConfidence,
      source: server.bpWipeSource,
      label: (t) => value === 'no' ? t.no : t.yes
    };
  }
  const text = `${server.name || ''} ${server.description || ''} ${(server.tags || []).join(' ')}`.toLowerCase();
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(text)) {
    return { value: 'no', confidence: 'medium', source: 'name/tags/description', label: (t) => t.no };
  }
  if (/bp wipe|blueprint wipe|full wipe|вайп чертеж/.test(text)) {
    return { value: 'yes', confidence: 'low', source: 'name/tags/description', label: (t) => t.yes };
  }
  return { value: 'unknown', confidence: null, source: null, label: (t) => t.unknown };
}

function sourceLabel(server, t) {
  if (server.ownerVerified) return t.verified;
  if (server.mapSizeSource === 'a2s.rules' || server.bpWipeSource === 'a2s.rules' || server.pingMs) return t.sourceA2s;
  if (server.wipeSource === 'steam.gametype.born') return t.sourceBorn;
  if (server.wipeSource === 'server.tags' || server.tags?.length) return t.officialTag;
  if (server.wipeSource === 'name/description' || server.gatherRateDetected || server.groupLimitDetected) return t.nameDetected;
  if (server.lastWipeDetected) return t.historyEstimated;
  return t.sourceEstimate;
}

function hasStrongSource(server) {
  return Boolean(
    server.ownerVerified
    || server.mapSizeSource === 'a2s.rules'
    || server.bpWipeSource === 'a2s.rules'
    || server.wipeSource === 'steam.gametype.born'
    || (server.dataQuality || 0) >= 85
  );
}

function displayPopulation(server) {
  const max = Math.max(0, Number(server.maxPlayers) || 0);
  const raw = Math.max(0, Number(server.players) || 0);
  const active = max > 0 ? Math.min(raw, max) : raw;
  const queue = max > 0 ? Math.max(0, raw - max) : 0;
  return {
    raw,
    active,
    queue,
    max,
    ratio: percentage(active, max)
  };
}

function buildWipeBuckets(servers) {
  const ranges = [
    { key: 'under10', labelKey: 'wipeUnder10', min: 0, max: 10 },
    { key: '10to30', labelKey: 'wipe10to30', min: 10, max: 30 },
    { key: '30to60', labelKey: 'wipe30to60', min: 30, max: 60 },
    { key: 'today', labelKey: 'wipedToday', min: 60, max: 1440 }
  ];
  return ranges.map((range) => ({
    ...range,
    label: range.labelKey,
    servers: servers
      .filter((server) => {
        const age = ageMinutes(server.lastWipeDetected);
        return age !== null && age >= range.min && age < range.max;
      })
      .sort((a, b) => b.radarScore - a.radarScore)
      .slice(0, 4)
  }));
}

function optionLabel(value, t) {
  const map = {
    all: t.all,
    vanilla: t.vanilla,
    modded: t.modded,
    official: t.official,
    pve: t.pve,
    players: t.players,
    fresh: t.updatedAgo,
    confidence: t.confidence,
    radar: t.ranking,
    verified: t.strongData,
    high: t.highPop,
    medium: 'Medium',
    low: 'Low',
    no: t.no,
    yes: t.yes,
    unknown: t.unknown
  };
  return map[value] || value;
}

function formatRelative(value, t) {
  if (!value) return t.unknown;
  const diff = Date.now() - new Date(value).getTime();
  if (diff < -5 * 60000) return t.unknown;
  if (diff < 0) return '0 min';
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return t.today;
  return `${days} d`;
}

function formatRelativePast(value, t) {
  if (!value) return t.unknown;
  const diff = Date.now() - new Date(value).getTime();
  const seconds = Math.max(0, Math.floor(diff / 1000));
  if (seconds < 60) return `${seconds} s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  return `${Math.floor(hours / 24)} d`;
}

function formatDate(value, withYear = false) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: withYear ? '2-digit' : undefined,
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function percentage(players, maxPlayers) {
  if (!maxPlayers) return 0;
  return Math.max(0, Math.min(100, Math.round(((players || 0) / maxPlayers) * 100)));
}

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(value || 0);
}

function dateValue(value) {
  return value ? new Date(value).getTime() || 0 : 0;
}

function readJson(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
}

function detectLanguage() {
  const code = navigator.language?.slice(0, 2).toLowerCase();
  return LANGS.includes(code) ? code : 'de';
}

export default App;
